import { useState } from "react";
import { useAuth } from "../lib/auth";
import { api, formatApiError } from "../lib/api";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Textarea } from "../components/ui/textarea";
import { toast } from "sonner";

export default function ProfilePage() {
  const { user, refresh } = useAuth();
  const [name, setName] = useState(user?.name || "");
  const [phone, setPhone] = useState(user?.phone || "");
  const [bio, setBio] = useState(user?.bio || "");
  const [phonePrivate, setPhonePrivate] = useState(!!user?.phone_private);
  const [audioKeep, setAudioKeep] = useState(!!user?.audio_default_keep);
  const [emailMuted, setEmailMuted] = useState(!!user?.notification_prefs?.email_muted);

  // change password
  const [cp, setCp] = useState(""); const [np, setNp] = useState(""); const [np2, setNp2] = useState("");

  async function saveProfile(e) {
    e.preventDefault();
    try {
      await api.patch("/profile", {
        name, phone, bio, phone_private: phonePrivate,
        audio_default_keep: audioKeep, email_muted: emailMuted,
      });
      await refresh();
      toast.success("Profile updated");
    } catch (err) { toast.error(formatApiError(err)); }
  }

  async function savePassword(e) {
    e.preventDefault();
    if (np.length < 6) return toast.error("Password must be at least 6 characters");
    if (np !== np2) return toast.error("Passwords don't match");
    try {
      await api.post("/auth/change-password", { current_password: cp, new_password: np });
      setCp(""); setNp(""); setNp2("");
      toast.success("Password updated");
    } catch (err) { toast.error(formatApiError(err)); }
  }

  return (
    <div className="px-5 md:px-10 py-6 md:py-10 max-w-2xl">
      <div className="text-xs uppercase tracking-widest text-stone-500 font-bold">Profile</div>
      <h1 className="font-serif-display text-3xl md:text-4xl font-semibold mt-1">Your details</h1>

      <form onSubmit={saveProfile} className="mt-7 bg-white border border-stone-200 rounded-2xl p-6 space-y-4" data-testid="profile-form">
        <div><Label>Name</Label><Input value={name} onChange={(e) => setName(e.target.value)} data-testid="pf-name" className="h-11 mt-1.5" /></div>
        <div><Label>Phone</Label><Input value={phone} onChange={(e) => setPhone(e.target.value)} data-testid="pf-phone" className="h-11 mt-1.5" /></div>
        <div>
          <Label>About you (visible to neighbours)</Label>
          <Textarea rows={3} value={bio} onChange={(e) => setBio(e.target.value)} data-testid="pf-bio" className="mt-1.5"
            placeholder="e.g. I run a small bakery from home. Always happy to help with maintenance volunteering." />
        </div>
        <div className="space-y-2.5 pt-2">
          <label className="flex items-center gap-3 text-sm">
            <input type="checkbox" checked={phonePrivate} onChange={(e) => setPhonePrivate(e.target.checked)} data-testid="pf-priv" className="w-5 h-5 accent-[#C05640]" />
            <span>Hide my phone number from other residents</span>
          </label>
          <label className="flex items-center gap-3 text-sm">
            <input type="checkbox" checked={audioKeep} onChange={(e) => setAudioKeep(e.target.checked)} data-testid="pf-aud" className="w-5 h-5 accent-[#C05640]" />
            <span>Keep my voice recordings by default when raising issues</span>
          </label>
          <label className="flex items-center gap-3 text-sm">
            <input type="checkbox" checked={emailMuted} onChange={(e) => setEmailMuted(e.target.checked)} data-testid="pf-mute" className="w-5 h-5 accent-[#C05640]" />
            <span>Mute email notifications</span>
          </label>
        </div>
        <Button type="submit" data-testid="pf-save" className="rounded-full bg-[#C05640] hover:bg-[#A54734]">Save changes</Button>
      </form>

      <h2 className="font-serif-display text-xl font-medium mt-9 mb-3">Change password</h2>
      <form onSubmit={savePassword} className="bg-white border border-stone-200 rounded-2xl p-6 space-y-3" data-testid="pwd-form">
        <div><Label>Current password</Label><Input type="password" required value={cp} onChange={(e) => setCp(e.target.value)} data-testid="cp-old" className="h-11 mt-1.5" /></div>
        <div><Label>New password</Label><Input type="password" required value={np} onChange={(e) => setNp(e.target.value)} data-testid="cp-new" className="h-11 mt-1.5" /></div>
        <div><Label>Confirm new password</Label><Input type="password" required value={np2} onChange={(e) => setNp2(e.target.value)} data-testid="cp-new2" className="h-11 mt-1.5" /></div>
        <Button type="submit" data-testid="cp-save" className="rounded-full bg-stone-900 text-white">Update password</Button>
      </form>
    </div>
  );
}
